import { useEffect, useRef, useState } from 'react';

let bannerSeen = false;

const showDelay = 5 * 1000;

export function useShowSnackbar() {
  const shouldShowBannerRef = useRef(!bannerSeen);
  if (shouldShowBannerRef.current) {
    bannerSeen = true;
  }

  const snackbarState = useState(false);
  const [showSnackbar, setShowSnackbar] = snackbarState;
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();
  // Display snackbar after 5 seconds
  useEffect(() => {
    const clearRunTimeout = () => timeoutRef.current && clearTimeout(timeoutRef.current);
    if (shouldShowBannerRef.current === true && showSnackbar === false) {
      timeoutRef.current = setTimeout(() => {
        setShowSnackbar(true);
      }, showDelay);
    }
    return () => clearRunTimeout();
  }, [showSnackbar, setShowSnackbar]);

  useEffect(() => {
    if (showSnackbar === false) {
      shouldShowBannerRef.current = false;
    }
  }, [showSnackbar]);

  return snackbarState;
}
